<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/task/table">任务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-row :gutter="24">
      <layout-panel>
        <template slot="header">{{$route.meta.title}}</template>
        <el-table :data="table"
                  stripe
                  highlight-current-row
                  :show-header="false"
                  class="margin b15"
                  style="width: 100%">
          <el-table-column width="150">
            <template slot-scope="scope">
              <b>{{scope.row.label}}</b>
            </template>
          </el-table-column>
          <el-table-column min-width="150">
            <template slot-scope="scope">
              <span v-if="ifSelect(scope)">
                <span v-for="item in options[scope.row.key]"
                      v-if="scope.row.value === item.value">{{item.label}}</span>
              </span>
              <span v-else-if="scope.row.key === 'platformtype'">
                {{ platformtypeLabel(scope.row.value) }}
              </span>
              <span v-else-if="scope.row.key === 'salary'">
              {{salaryValue(scope.row.value)}}元
              </span>
              <span v-else-if="scope.row.key === 'managementfee' ">
              {{scope.row.value}}元
              </span>
              <span v-else-if="scope.row.key === 'points'">
              {{scope.row.value}}零豆
              </span>
              <span v-else-if="scope.row.key === 'validcheckindistance'">
              {{scope.row.value}}公里
              </span>
              <span v-else-if="scope.row.key === 'taskid'">
              TSK{{scope.row.value}}
              </span>
              <template v-else-if="scope.row.key === 'templateid'">
                <router-link v-if="data.templateid !== '0'" :to="'/step-template/update/'+data.templateid">
                  <span class="blue-color">{{templateTitle}}/{{scope.row.value}}</span>
                </router-link>
              </template>
              <span v-else-if="scope.row.key === 'customername'">
                <router-link :to="'/task/table?customerid='+data.customerid">
                  <span class="blue-color">{{data.customername}}</span>
                </router-link>
              </span>
              <span v-else-if="scope.row.key === 'projectname'">
                <router-link :to="'/task/table?projectid='+data.projectid">
                  <span class="blue-color">{{data.projectname}}</span>
                </router-link>
              </span>
              <span v-else-if="scope.row.key === 'batchname'">
                <router-link :to="'/task/table?batchid='+data.batchid">
                  <span class="blue-color">{{data.batchname}}</span>
                </router-link>
              </span>
              <span v-else-if="scope.row.key === 'marketname'">
              <span>{{data.marketname}}/{{data.marketid}}</span>
              </span>
              <span v-else-if="scope.row.key === 'provincename'">
              <span>
                {{data.provincename}}{{data.cityname}}{{data.areaname}}</span>
              </span>
              <span v-else-if="scope.row.key === 'marketinfo'">
              <span>{{data.latitude}},{{data.longitude}}</span><br/>
              </span>
              <span v-else-if="scope.row.key === 'address' && data.marketid > 0">
                <span v-if="data.marketinfo && data.marketinfo.address">{{data.marketinfo.address}}</span><br/>
              </span>
              <span v-else-if="scope.row.key === 'hirenum'">
              <span>{{scope.row.value}}人</span>
              </span>
              <span v-else-if="scope.row.key === 'blackList' || scope.row.key === 'whiteList'">
               <span v-for="item in scope.row.value"
                     class="blue-color">
                <router-link :to="'/users/detail/info?userid='+item.userid">
                <span v-if="item.nickname">{{item.nickname}}</span>
                <span v-if="item.realname">/{{item.realname}}</span>
                <span v-if="item.cellphone">/{{item.cellphone}}</span><br/>
                </router-link>
                </span>
              </span>
              <span v-else-if="scope.row.key === 'blackListTags' || scope.row.key === 'whiteListTags'">
                <span v-for="item in scope.row.value">
                {{item.tagname}}/{{item.id}}<br/>
                </span>
              </span>
              <span v-else-if="scope.row.key === 'photo'">
                <span v-for="item in scope.row.value">
                  <el-image
                    :src="item"
                    style="width: 100px; cursor: pointer;"
                    :preview-src-list="scope.row.value"
                    alt="爱零工">
                  </el-image>
                </span>
              </span>
              <span v-else-if="scope.row.key === 'adminname'">
              <span>{{data.adminname}}({{data.adminid}})</span>
              </span>
              <span v-else-if="scope.row.key === 'is_group_task'">{{data.is_group_task ? '是' : '否'}}</span>
              <span v-else-if="scope.row.key === 'task_group_status'">{{data.task_group_status ? '开启' : '关闭'}}</span>
              <span v-else-if="scope.row.key === 'need_full_workinfo'">{{data.need_full_workinfo > 0 ? '是' : '否'}}</span>
              <span v-else-if="scope.row.key === 'userprocesslog'">
              <span v-if="scope.row.value">
              <span v-for="item in  JSON.parse(scope.row.value)">
                <span>{{formatUnix(item.timestamp)}}
                  用户
                  <router-link :to="'/users/detail/info?userid='+item.userid">
                    <span class="blue-color">{{item.userid}}</span>
                  </router-link>{{item.action}}
                </span><br/>
              </span>
              </span>
              </span>
              <span v-else-if="scope.row.key === 'adminprocesslog'">
              <span v-if="scope.row.value">
                <span v-for="item in  JSON.parse(scope.row.value)">
                <span>{{formatUnix(item.timestamp)}}
                {{item.adminname}} {{item.action}}</span><br/>
                </span>
              </span>
              </span>
              <span v-else-if="scope.row.key === 'templatejson'">
              <!--<router-link :to="'/order/review/'+data.taskid">-->
              {{data.title}}
                <!--</router-link>-->
              </span>
              <span v-else-if="scope.row.key === 'checkinlocation'">
              {{data.checkinlocation}} (距离商场：{{data.checkindistance}}米)
              </span>
              <span v-else-if="scope.row.key === 'finishlocation'">
              {{data.finishlocation}} (距离商场：{{data.finishdistance}}米)
              </span>
              <span v-else-if="scope.row.key === 'userid'">
              <span v-if="scope.row .value !== 0">
                <router-link :to="'/users/table?keyword='+data.userid">
                  <span v-if="data.userinfo && data.userinfo.cellphone"
                        class="blue-color">{{data.userinfo.cellphone}}/</span>{{data.userid}}
                </router-link>
                </span>
              </span>
              <span v-else-if="scope.row.key === 'content'">
                <span v-html="scope.row.value"></span>
              </span>
              <p v-else-if="scope.row.key === 'availableTime'"
                 v-for="availableTime in scope.row.value">
                {{availableTime.starttime}} - {{availableTime.endtime}}
              </p>
              <span v-else>{{scope.row.value}}</span>
            </template>
          </el-table-column>
        </el-table>
        <router-link to="/task/table">
          <el-button type="primary"
                     size="mini">返回
          </el-button>
        </router-link>
      </layout-panel>
    </el-row>
  </div>
</template>

<script>

export default {
  components: {},
  data () {
    return {
      taskid: null,
      data: {},
      table: [
        {
          key: 'taskid',
          label: '任务ID',
          value: '',
        }, {
          key: 'strstatus',
          label: '任务状态',
          value: '',
        }, {
          key: 'cacheuploadstatus',
          label: '任务缓存状态',
          value: '',
        }, {
          key: 'title',
          label: '任务标题',
          value: '',
        }, {
          key: 'strtype',
          label: '任务类型',
          value: '',
        }, {
          key: 'taskmarketareaid',
          label: '任务区域',
          value: '',
        }, {
          key: 'salary',
          label: '赏金',
          value: '',
        }, {
          key: 'managementfee',
          label: '管理费',
          value: '',
        }, {
          key: 'points',
          label: '积分',
          value: '',
        }, {
          key: 'validcheckindistance',
          label: '有效签到距离',
          value: '',
        }, {
          key: 'showtime',
          label: '任务预览开始时间',
          value: '',
        }, {
          key: 'starttime',
          label: '任务上线时间',
          value: '',
        }, {
          key: 'deadline',
          label: '任务下线时间',
          value: '',
        }, {
          key: 'taskendtime',
          label: '任务结束时间',
          value: '',
        }, {
          key: 'endtime',
          label: '用户最晚完成时间',
          value: '',
        }, {
          key: 'processingtime',
          label: '任务最晚完成时间限制(小时)',
          value: '',
        }, {
          key: 'reviewtime',
          label: '审核时间(天)',
          value: '',
        }, {
          key: 'availableTime',
          label: '任务可执行时间',
          value: '',
        }, {
          key: 'clientversion',
          label: '用户App版本',
          value: '',
        }, {
          key: 'clientosversion',
          label: '用户手机OS版本',
          value: '',
        }, {
          key: 'clientmodel',
          label: '用户手机型号',
          value: '',
        }, {
          key: 'devicenum',
          label: '用户设备号',
          value: '',
        }, {
          key: 'uservietime',
          label: '用户抢单时间',
          value: '',
        }, {
          key: 'userstarttime',
          label: '用户开始时间',
          value: '',
        }, {
          key: 'userfinishtime',
          label: '用户完成时间',
          value: '',
        }, {
          key: 'content',
          label: '任务详细描述',
          value: '',
        }, {
          key: 'seriestasktemplateid',
          label: '系列任务模板ID',
          value: '',
        }, {
          key: 'templateid',
          label: '任务模板ID',
          value: '',
        }, {
          key: 'customername',
          label: '客户编号',
          value: '',
        }, {
          key: 'projectname',
          label: '项目编号',
          value: '',
        }, {
          key: 'batchname',
          label: '批次编号',
          value: '',
        }, {
          key: 'gpsCheck',
          label: '任务提交是否验证GPS位置',
          value: '',
        }, {
          key: 'priority',
          label: '任务是否置顶',
          value: '',
        }, {
          key: 'superuserprior',
          label: '是否金牌人员优先',
          value: '',
        }, {
          key: 'onlynearby',
          label: '是否不在任务大厅显示',
          value: '',
        }, {
          key: 'multitimes',
          label: '是否准许多次接单',
          value: '',
        }, {
          key: 'rejectuserrepeat',
          label: '审核不通过时用户是否可重复执行',
          value: '',
        }, {
          key: 'dynamic_adjust_salary',
          label: '过程中调价',
          value: '',
        }, {
          key: 'allow_coupon',
          label: '允许使用优惠券',
          value: '',
        }, {
          key: 'use_servercache',
          label: '服务器缓存',
          value: '',
        }, {
          key: 'ostype',
          label: '发布平台',
          value: '',
        }, {
          key: 'platformtype',
          label: '发布App',
          value: '',
        }, {
          key: 'minclientversionforandroid',
          label: '爱零工安卓客户端最低版本',
          value: '',
        }, {
          key: 'minclientversionforios',
          label: '爱零工IOS客户端最低版本',
          value: '',
        }, {
          key: 'minclientversionforandroid_clb',
          label: '查理宝安卓客户端最低版本',
          value: '',
        }, {
          key: 'minclientversionforios_clb',
          label: '查理宝IOS客户端最低版本',
          value: '',
        }, {
          key: 'marketname',
          label: '任务所属商场',
          value: '',
        }, {
          key: 'provincename',
          label: '任务城市',
          value: '',
        }, {
          key: 'address',
          label: '门店地址',
          value: '',
        }, {
          key: 'marketinfo',
          label: '任务位置',
          value: '',
        }, {
          key: 'hirenum',
          label: '需要人数',
          value: '',
        }, {
          key: 'blackList',
          label: '黑名单',
          value: '',
        }, {
          key: 'blackListTags',
          label: '黑名单标签',
          value: '',
        }, {
          key: 'whiteList',
          label: '白名单',
          value: '',
        }, {
          key: 'whiteListTags',
          label: '白名单标签',
          value: '',
        }, {
          key: 'photo',
          label: '任务照片',
          value: '',
        }, {
          key: 'adminname',
          label: '添加管理员',
          value: '',
        }, {
          key: 'is_group_task',
          label: '是否为群组任务',
          value: '',
        }, {
          key: 'task_group_status',
          label: '群组任务开启状态',
          value: '',
        }, {
          key: 'need_full_workinfo',
          label: '限已完善职业信息用户抢单',
          value: '',
        }, {
          key: 'userprocesslog',
          label: '用户操作日志',
          value: '',
        }, {
          key: 'adminprocesslog',
          label: '管理员操作日志',
          value: '',
        }, {
          key: 'templatejson',
          label: '模板任务完成情况',
          value: '',
        }, {
          key: 'checkinlocation',
          label: '任务签到GPS位置',
          value: '',
        }, {
          key: 'finishlocation',
          label: '任务完成后GPS位置',
          value: '',
        }, {
          key: 'userid',
          label: '任务完成人',
          value: '',
        }, {
          key: 'errormessage',
          label: '审核不通过原因',
          value: '',
        }],
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.order.options,
    }),
    templateTitle () {
      if (this.data.templatejson === null) {
        return ''
      } else if (typeof this.data.templatejson === 'string') {
        return JSON.parse(this.data.templatejson).title
      }
      return this.data.templatejson.title
    }
  },
  created () {
    this.taskid = this.$route.params.taskid
    this.taskid > 0 && this.setDetailData(this.taskid)
  },
  methods: {
    ...Vuex.mapActions([]),
    setDetailData (id) {
      request.page('getTaskDetail', {id: id}).then(({data}) => {
        this.data = data
        if (this.data.userinfo) {
          this.data.clientversion = this.data.userinfo.clientversion
          this.data.clientmodel = this.data.userinfo.clientmodel
          this.data.devicenum = this.data.userinfo.devicenum
        } else {
          this.data.clientversion = ''
          this.data.clientmodel = ''
          this.data.devicenum = ''
        }
        this.table.forEach(obj => {
          if (data.hasOwnProperty(obj.key)) {
            obj.value = data[obj.key]
          }
        })
        if (data.hasOwnProperty('is_group_task') && data.is_group_task === false) {
          for (let i in this.table) {
            if (this.table.hasOwnProperty(i) && this.table[i].key === 'task_group_status') {
              this.table.splice(i, 1)
              break
            }
          }
        }
        // 门店任务 显示门店地址
        if (data.hasOwnProperty('marketid') && data.marketid === 0) {
          this.table = this.table.filter(item => item.key !== 'address')
        }
      })
    },
    ifSelect (scope) {
      let item = ['cacheuploadstatus', 'taskmarketareaid', 'gpsCheck', 'priority', 'superuserprior',
        'multitimes', 'rejectuserrepeat', 'rejecttaskrepeat', 'allow_coupon', 'use_servercache', 'ostype', 'onlynearby']
      for (let i = 0; i < item.length; i++) {
        if (scope.row.key === item[i]) {
          return true
        }
      }
      return false
    },
    formatUnix (time) {
      return filter.formatUnix(time)
    },
    salaryValue (value) {
      return filter.hasPermission(250) ? value : '*'
    },
    platformtypeLabel (v) {
      const m = {
        0: '爱零工',
        8: '查理宝',
        9: '全选',
        1: '查理宝(旧)',
        2: '标注任务',
        3: 'Teke',
        6: '中台任务',
        7: 'DataCapture',
      }
      const n = Number(v)
      return m[n] !== undefined ? m[n] : (v === '' || v === null ? '' : String(v))
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
a {
  text-decoration: none;
}

.blue-color {
  color: rgb(88, 157, 248);
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/task/pages/TaskDetail.vue